import { yupResolver } from '@hookform/resolvers/yup';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormControl from '@material-ui/core/FormControl';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import useNotifications from '../../redux/notifications/notifications.hooks';
import useSynchronizationDialog from '../../redux/synchronization-dialog/synchronization-dialog.hooks';
import { useTriggerSynchronizationMutation } from '../../redux/synchronization/synchronization.api';
import DialogForm from '../forms/dialog-form';
import FormTextField from '../forms/form-text-field';

interface SynchronizationDialogForm {
  password: string;
}

interface SynchronizationDialogProps {
  onClose?: () => void;
}

export default function SynchronizationDialog(props: SynchronizationDialogProps) {
  const { onClose } = props;
  const { t } = useTranslation('common');
  const methods = useForm<SynchronizationDialogForm>({
    resolver: yupResolver(
      yup
        .object({
          password: yup.string().required(),
        })
        .required(),
    ),
  });
  const { isDialogOpen, closeDialog } = useSynchronizationDialog();
  const { show } = useNotifications();
  const [trigger] = useTriggerSynchronizationMutation({ fixedCacheKey: 'synchronization' });

  useEffect(() => {
    methods.reset();
  }, [isDialogOpen, methods]);

  const handleCancel = () => {
    closeDialog();
    if (onClose) {
      onClose();
    }
  };

  const handleSubmit = async (data: SynchronizationDialogForm) => {
    try {
      await trigger({ password: data.password }).unwrap();
      closeDialog();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      let message = t('common.error-unknown');
      if ('status' in error) {
        const status = error.status;

        if (status === 400) {
          message = t('synchronization-dialog.error-authentication');
        }
      }

      show({
        severity: 'error',
        message,
      });
    }
  };

  return (
    <DialogForm
      title={t('synchronization-dialog.title')}
      submitName={t('common.button-import')}
      methods={methods}
      open={isDialogOpen}
      onClose={handleCancel}
      onSubmit={handleSubmit}
    >
      <DialogContentText>
        {t('synchronization-dialog.message-info-header')}
        <ul>
          <li>{t('synchronization-dialog.message-info-item-1')}</li>
          <li>{t('synchronization-dialog.message-info-item-2')}</li>
          <li>{t('synchronization-dialog.message-info-item-3')}</li>
          <li>{t('synchronization-dialog.message-info-item-4')}</li>
        </ul>
        {t('synchronization-dialog.message-info-footer')}
      </DialogContentText>
      <FormControl fullWidth margin="normal">
        <FormTextField
          name="password"
          type="password"
          label={t('synchronization-dialog.label-finance-password')}
          autoFocus
        />
      </FormControl>
    </DialogForm>
  );
}
